export default __webpack_public_path__ + "static/media/Z.88f92c8a.png";